import { createRoot } from "react-dom/client";
import { MeetingApp } from "./MeetingApp.jsx";
import { ensureMeetStyles } from "./meet-styles.js";

ensureMeetStyles();
document.documentElement.style.height = "100%";
document.body.style.cssText = "margin:0;height:100%";
const root = document.getElementById("root");
root.style.height = "100%";
createRoot(root).render(<MeetingApp apiBase="" />);
